<script lang="ts">
  	import { createEventDispatcher } from 'svelte'
    import {appName} from '../appName'
    const dispatch = createEventDispatcher<{accept:void}>()
</script>

<div class="text-darkFore">Congratulations! You've completed the <i>{appName}</i> preview!<br/>Check back later for more content.</div>
<button class="btn-darkBackHigh text-orange float-right" on:click={() => {dispatch('accept')}}>OK</button>
